export default function Input({
  label,
  error,
  className = '',
  id,
  required,
  ...props
}) {
  const inputId = id || props.name;

  return (
    <div className={className}>
      {label && (
        <label
          htmlFor={inputId}
          className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5"
        >
          {label}
          {required && <span className="text-wine-600 ml-1">*</span>}
        </label>
      )}
      <input
        id={inputId}
        className={`
          w-full px-4 py-3
          bg-white dark:bg-gray-800
          border rounded-lg
          text-gray-900 dark:text-white
          placeholder-gray-400 dark:placeholder-gray-500
          transition-colors duration-200
          focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent
          min-h-[48px]
          ${error
            ? 'border-wine-500 focus:ring-wine-500'
            : 'border-gray-300 dark:border-gray-600'
          }
        `}
        required={required}
        {...props}
      />
      {error && (
        <p className="mt-1.5 text-sm text-wine-600 dark:text-wine-400">{error}</p>
      )}
    </div>
  );
}
